import { render } from "./Home.vue?vue&type=template&id=545ee480"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=545ee480&lang=css"
script.render = render

export default script